'use client';

import AdditionalProfileFieldsForm from '../forms/AdditionalProfileFieldsForm';
import { useLanguage } from '@/lib/i18n/LanguageContext';
import { Modal } from '@/components/ui/Modal';

interface AdditionalProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  courseId: string;
  courseTitle?: string;
  onComplete: () => void;
}

export default function AdditionalProfileModal({
  isOpen,
  onClose,
  courseId,
  courseTitle,
  onComplete
}: AdditionalProfileModalProps) {
  const { t } = useLanguage();

  const handleSubmit = () => {
    // Form component handles the API call
    onComplete();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('additionalFields.completeProfile')}
      description={undefined}
      size="2xl"
    >
      <div className="max-h-[60vh] overflow-y-auto -mx-6 px-6">
        <AdditionalProfileFieldsForm
          courseId={courseId}
          onSubmit={handleSubmit}
          onCancel={onClose}
          submitText={t('additionalFields.saveAndContinue')}
          cancelText={t('common.cancel')}
        />
      </div>
    </Modal>
  );
}
